var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33325H3.33325V36.6666H18.3333V3.33325ZM21.6666 36.6666H36.6666V21.6666H21.6666V36.6666ZM36.6666 18.3333V3.33325H21.6666V18.3333H36.6666Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.291b2cd3b9f6ce0de66eee5553585308.svg";
export { ForwardRef as ReactComponent };